import { AuthAPI } from '../api/auth';
import { apiPost } from '../lib/http';
import { authManager } from './AuthManager';
import { pushService } from './PushService';

export class AuthService {
  static async logout(): Promise<void> {
    try {
      await pushService.unsubscribeCurrentDevice();
    } catch (err) {
      console.warn('Failed to unsubscribe from push notifications during logout:', err);
    }

    const refreshToken = authManager.getRefreshToken();
    if (refreshToken) {
      await apiPost(AuthAPI.logout(), { refresh_token: refreshToken });
    }
    authManager.logoutAndRedirect();
  }
}
